var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("VForm", {
    attrs: { "on-submit-async": _vm.submit },
    on: {
      success: function(value) {
        return this$1.$emit("success", value)
      }
    },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function(ref) {
          var form = ref.form
          return [
            _c("EmployeeCreateAndUpdateFormItems", {
              attrs: {
                form: form,
                "is-create-form": true,
                "stadium-id": _vm.stadiumId,
                "admin-mode": _vm.adminMode
              }
            }),
            _c("PeopleCreateAndUpdateFormItems", { attrs: { form: form } })
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }